import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 94%;
  padding-top: 32px;
  margin-left: 136px;
  margin-right: 124px;

  .cards-container {
    display: flex;
    justify-content: center;
    width: 100%;
    height: auto;
    border-radius: 10px;
    background-color: ${(props) => props.theme.colors.white};

    padding-bottom: 40px;
    margin-bottom: 84px;
  }

  @media only screen and (max-width: 1400px) {
    height: 100%;
  }

  @media only screen and (max-width: 1050px) {
    margin-left: 80px;
    margin-right: 60px;
  }

  @media only screen and (max-width: 768px) {
    margin-left: 40px;
    margin-right: 40px;
  }
`;